export const lengthCounterTbl = [
  // HI/LO 0   1   2   3   4   5   6   7    8   9   A   B   C   D   E   F
  // ----------------------------------------------------------------------
  /* 0 */ 10, 254, 20, 2, 40, 4, 80, 6, 160, 8, 60, 10, 14, 12, 26, 14,
  /* 1 */ 12, 16, 24, 18, 48, 20, 96, 22, 192, 24, 72, 26, 16, 28, 32, 30
];


export const dutyCycleTbl = [];

export const noisePeriodTbl = [
  4, 8, 16, 32, 64, 96, 128, 160, 202, 254, 380, 508, 762, 1016, 2034, 4068
]